module.exports = __webpack_public_path__ + "img/ZWF_Michal_Zuzanna.edfff40b.jpg";